<template>
  <div class="container">
    <img class="QRcode" :src="QrCodeUrl" alt="" />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import utils from "../../common/utils/utils";
import { mapState } from "vuex";
export default {
  name: 'MyQRcode',
  data() {
    return {
      data: null,
      QrCodeUrl: ''
    }
  },
  computed: {
    ...mapState(["Openid"]),
  },
  created() {
    this.getQRcode();
    this.hideShareMenu();
  },
  methods: {
    getQRcode() {
      this.$axios.get('/Api/Api/web/GetWeChatQrcode/AddBP?OpenID=' + this.Openid).then(res => {
        if (res.RetCode == '10000') {
          this.data = res.Data;
          this.QrCodeUrl = process.env.VUE_APP_BASE_URL + '/Api' + res.Data.QrCodeUrl; // qa环境
        } else {
          this.$toast(res.RetMsg);
        }
      })
    },
    hideShareMenu() {
      const entryLink = utils.getEntryLink();
      this.$axios.get("/Api/Api/web/WechatHelper/GetWechat?backUrl=" + entryLink).then(res => {
        wx.config({
          debug: false,
          appId: res.Data.AppId,
          timestamp: res.Data.TimesTamp,
          nonceStr: res.Data.NonceStr,
          signature: res.Data.She1Str,
          jsApiList: ["hideAllNonBaseMenuItem"],
        });
      })
      wx.checkJsApi({
        jsApiList: ["hideAllNonBaseMenuItem"],
        success: function() {
          wx.ready(() => {
            wx.hideAllNonBaseMenuItem();
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    // background-image: url('../../assets/images/poster@3x.png');
    // background-repeat: no-repeat;
    // background-size: cover;
    // background-color: #F9F9F9;
    text-align: center;
    .QRcode {
      // position: relative;
      // top: 435px;
      // width: 120px;
      // height: 120px;
      width: 100%;
      // height: 100%;
    }
  }
</style>